// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2Q81g","col":"Table_col__j0mlC","fulfillmentStatus":"Table_fulfillmentStatus__3sWVs","emailCol":"Table_emailCol__1byet"};